<div class="container-box">
  <app-table-header
    (btnUpdateClick)="reloadTrigger$.next()"
    [showNewButton]="false"
    tableTitle="Anagrafica clienti"
  >
    <!-- TODO: Attivare il bottone "Nuovo" quando sarà implementato il dialog di creazione -->
    <!-- <button mat-raised-button color="primary" (click)="newCustomer()">
      <mat-icon>add</mat-icon>
      Nuovo Cliente BP
    </button> -->
  </app-table-header>
  <div>
    <div class="table-container">
      <app-new-table
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'numeroBp',
          direction: 'asc'
        }"
        [reloadTrigger$]="reloadTrigger$"
      ></app-new-table>
    </div>
  </div>
</div>
